import { render } from "./Jornadas.vue?vue&type=template&id=7b367b7b&scoped=true"
import script from "./Jornadas.vue?vue&type=script&lang=js"
export * from "./Jornadas.vue?vue&type=script&lang=js"

import "./Jornadas.vue?vue&type=style&index=0&id=7b367b7b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b367b7b"]])

export default __exports__